import { ProductEnvironment } from './product-environment';

export interface ProductIdentifier<T = ProductEnvironment> {
  productId: string;
  environment: T;
}
